// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__2YCMM","overlay":"Modal_overlay__16re0","load":"Modal_load__2ZCqf"};